import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { SocialSigninService } from '../../social-signin/social-signin.service';

@Component({
    standalone: false,
    selector: 'abs-reset-password-confirm',
    template: `
        <abs-page-layout [pageTitle]="'GLOBAL.LOGIN.RESET_PASSWORD.CONFIRM_TITLE' | translate">
            <ng-container *ngIf="!success; else successMessage">
                <form [formGroup]="passwordForm" (ngSubmit)="submit()" class="content">
                    <div class="form-row">
                        <ion-label>{{ 'GLOBAL.LOGIN.RESET_PASSWORD.NEW_PASSWORD' | translate }}</ion-label>
                        <ion-input type="password" formControlName="password"></ion-input>
                    </div>
                    <p class="error" *ngIf="error">{{ 'GLOBAL.ERRORS.' + error | translate }}</p>
                    <div class="buttons">
                        <ion-button type="submit" [disabled]="passwordForm.invalid || submitting">
                            {{ 'GLOBAL.LOGIN.RESET_PASSWORD.SUBMIT' | translate }}
                        </ion-button>
                    </div>
                </form>
            </ng-container>
            <ng-template #successMessage>
                <p class="content">{{ 'GLOBAL.LOGIN.RESET_PASSWORD.SUCCESS' | translate }}</p>
            </ng-template>
        </abs-page-layout>
    `
})
export class ResetPasswordConfirmPage implements OnInit {
    oobCode: string;
    submitting = false;
    success = false;
    error: string = null;

    passwordForm = this.fb.group({
        password: this.fb.control('', [Validators.required, Validators.minLength(8)])
    });

    constructor(
        private fb: UntypedFormBuilder,
        private socialSignin: SocialSigninService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.route.queryParams.subscribe((params) => {
            this.oobCode = params['oobCode'];
        });
    }

    async submit() {
        if (this.passwordForm.invalid) {
            return;
        }

        this.error = null;
        this.submitting = true;

        try {
            await this.socialSignin.confirmNewPassword(this.oobCode, this.passwordForm.value.password);
            this.success = true;
        } catch (err: any) {
            this.error = err.code || 'UNKNOWN';
        } finally {
            this.submitting = false;
        }
    }
}
